<template>
  <div class="conetnt">
    <div class="product">
      <div class="breadcrumbs">
        <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
          <svg class="icon" aria-hidden="true" style="fill: #fff">
            <use xlink:href="#icon-shangpin"></use>
          </svg>
        </breadcrumbs>
      </div>

      <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" :disabled="loading"
        @change="onChangeActiveTab" />
      <div class="content-wrap">
        <div class="content-main">
          <div class="content-main-reFetch">
            <reFetch :key="product" type="product" :refetch="getData" :activeTab="Number(activeTab)" />
            <fileBar :params="params" :getProductList="getData" :exportsNum="exportsNum" :activeTab="activeTab" />
          </div>

          <div class="content">
            <operationBar ref="operationBarRef" :onChangeActiveItems="onChangeActiveItems"
              :selectedRowKeys="selectedRowKeys" :setSelectedRowKeys="setSelectedRowKeys" :productList="productList"
              :getProductList="getData" :params="params" :setParams="setParams" :listTotal="listTotal"
              :setShowSetCommission="setShowSetCommission" :brandswithAvailableProducts="brandswithAvailableProducts"
              :amazonNameList="amazonNameList" :activeTab="activeTab" />
            <tableContent ref="tableContentRef" :setParams="setParams" :loading="loading" :noData="noData"
              :params="params" :dataSource="productList" :brandswithAvailableProducts="brandswithAvailableProducts"
              :selectedRowKeys="selectedRowKeys" :getProductList="getData" :activeTab="activeTab"
              :onSelectChange="onSelectChange" :total="total" :onChangeActiveItems="onChangeActiveItems"
              :listTotal="listTotal" :setShowSetCommission="setShowSetCommission"
              :setSelectedRowKeys="setSelectedRowKeys" :setSelectSingleProduct="setSelectSingleProduct"
              @cancel="getData" @multiCancel="multiCancel" />
          </div>
        </div>
      </div>

      <setPublicCommission :type="'product'" :showSetCommission="showSetCommission" :productList="productList"
        :selectedRowKeys="selectedRowKeys" :setShowSetCommission="setShowSetCommission" :getProductList="getData"
        :selectSingleProduct="selectSingleProduct" :setSelectSingleProduct="setSelectSingleProduct"
        :item="singleRecord" />
      <productModel ref="productModelRef" />
      <contextHolder />
    </div>
    <div class="bottom-content" v-if="selectedRowKeys.length">
      <div class="left">{{ $t('seller.common.selected') }} ({{ selectedRowKeys.length }})</div>
      <div class="right">
        <div :class="productListStatus.activeProductCount ? 'btn-style' : 'btn-style disable'" @click="
          changeProducts('active', productListStatus.activeProductCount+productListStatus.activeProductVariationCount)
          ">
          {{ $t('seller.common.activateProducts') }}
          <div class="num">
            {{ productListStatus.activeProductCount }}
          </div>
          <Icon name="jiahao-cu" class="minus" v-if="productListStatus.activeProductVariationCount"></Icon>
          <div class="num-two num-two-white" v-if="productListStatus.activeProductVariationCount">
            {{ productListStatus.activeProductVariationCount }}
          </div>
          <a-tooltip placement="bottom" v-if="productListStatus.activeProductVariationCount">
            <template #title>
              <div class="pop-title">
                {{ $t('seller.common.variationTooltip') }}
              </div>
            </template>
            <Icon name="wenhao-tianchong" class="icon-style" />
          </a-tooltip>
        </div>
        <div :class="productListStatus.inactiveProductCount ? 'btn-style' : 'btn-style disable'" @click="
          changeProducts('deactive', productListStatus.inactiveProductCount+productListStatus.inactiveProductVariationCount)
          ">
          {{ $t('seller.common.deactivateProducts') }}
          <div class="num">
            {{ productListStatus.inactiveProductCount }}
          </div>
          <Icon name="jiahao-cu" class="minus" v-if="productListStatus.inactiveProductVariationCount"></Icon>
          <div class="num-two num-two-white" v-if="productListStatus.inactiveProductVariationCount">
            {{ productListStatus.inactiveProductVariationCount }}
          </div>
          <a-tooltip placement="bottom" v-if="productListStatus.inactiveProductVariationCount">
            <template #title>
              <div class="pop-title">
                {{ $t('seller.common.variationTooltip') }}
              </div>
            </template>
            <Icon name="wenhao-tianchong" class="icon-style" />
          </a-tooltip>
        </div>
        <!-- cancel-btn disable -->
        <div :class="productListStatus.pendingCount ? 'cancel-btn' : 'cancel-btn disable'" @click="cancel"
          ref="operationRef">
          {{ $t('seller.common.cancelStatusTask') }}
          <div class="num">
            {{ productListStatus.pendingCount }}

          </div>
          <Icon name="jiahao-cu" class="minus" v-if="productListStatus.pendingProductVariationCount"></Icon>
          <div class="num-two" v-if="productListStatus.pendingProductVariationCount">
            {{ productListStatus.pendingProductVariationCount }}
          </div>
          <a-tooltip placement="bottom" v-if="productListStatus.pendingProductVariationCount">
            <template #title>
              <div class="pop-title">
                {{ $t('seller.common.variationTooltip') }}
              </div>
            </template>
            <Icon name="wenhao-tianchong" class="icon-style" />
          </a-tooltip>

        </div>
        <div :class="selectedRowKeys?.length ? 'btn-style' : 'btn-style disable'" @click="setCommission" v-if="activeTab == '0'">
          {{ $t('seller.common.setCommission') }}
          <div class="num">
            {{ selectedRowKeys?.length }}

          </div>
        </div>
      </div>
    </div>
    <CancelSure ref="cancelSureRef" @ok="cancelSureOk" />
    <activeBrands :configs="configs" :item="brandDetail" @ok="activeBrandOk" />

  </div>
</template>
<script lang="jsx" setup>
import i18n from '~/i18n'

import { onBeforeMount, onMounted, ref, watch, computed, reactive, h } from 'vue'
import setPublicCommission from './setPublicCommission.vue'
import reFetch from '../Brands/components/reFetch.vue'
import productModel from './productModel.vue'
import { useUserInfoStore } from '../../../storeData'
import { useSellerProductStore } from '../../../storeData/sellerproduct'
import { productsApi, brandApi } from '../../../server/index'
import { connectionApi } from '@/server/seller/index'
import breadcrumbs from '../breadcrumbs.vue'
import tableContent from './tableContent.vue'
import operationBar from './operationBar.vue'
import fileBar from './fileBar/index.vue'
import { message, notification, Button } from 'ant-design-vue'
import { useSystemStore } from '@/storeData/system'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import CancelSure from './cancelSure.vue'
import Icon from '@/components/Icon.vue'
import activeBrands from './activeBrands.vue'

const { t, locale } = useI18n()
const cancelRowKeys = ref([])
const tableContentRef = ref(null)
const cancelSureRef = ref(null)
const operationBarRef = ref(null)
const selectAll = ref([])

const breadcrumbsData = computed(() => ({
  title: t('seller.menu.products'),
  color: '#4682FA',
  hasTitleIcon: true,
  links: [
    { name: t('seller.common.home'), path: '/seller/dashboard' },
    { name: t('seller.menu.products'), path: '/seller/product' },
  ],
}))
const user = useUserInfoStore()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
console.log(timezone,'timezone')
const router = useRouter()
const route = useRoute()
const productModelRef = ref(null)
const activeTab = ref('0')
const systemStore = useSystemStore()
/** 暂时隐藏 Products 页 Associate 标签页 */
const HIDE_ASSOCIATE_PRODUCT_TAB = true
const programConfig = computed(() => {
  locale.value
  let src = systemStore.programConfig
  if (!src?.length) return src
  if (HIDE_ASSOCIATE_PRODUCT_TAB) {
    src = src.filter((item) => item.key !== '1')
  }
  return src.map((item) => {
    if (item.key === '0') return { ...item, label: i18n.global.t('seller.common.amazonAttribution') }
    if (item.key === '1') return { ...item, label: i18n.global.t('seller.common.amazonAssociate') }
    return { ...item }
  })
})
const userStore = useUserInfoStore()
const store = useSellerProductStore()
const brandswithAvailableProducts = ref([])
const amazonNameList = ref([])
const selectSingleProduct = ref('')
const showSetCommission = ref(false)
const selectedRowKeys = ref([])
const loading = ref(false)
// 跟踪当前的选择模式：'all' - 全选, 'page' - 当前页, 'normal' - 常规选择
const selectionMode = ref('normal')
const productList = ref([])
const listTotal = ref(0)
const singleRecord = ref({})
const exportsNum = ref({
  activeProductCount: 0,
  allProductCount: 0,
  inActiveProductCount: 0,
  filterProductCount: 0,
})
const productListStatus = reactive({
  activeProductCount: 0,
  activeProductVariationCount: 0,
  inactiveProductCount: 0,
  inactiveProductVariationCount: 0,
  pendingCount: 0,
  pendingProductVariationCount: 0,
  activeProductIds: [],
  inactiveProductIds: [],
  pendingOperationIds: [],
})
const params = ref({
  availability: '',
  commission: '',
  maxPrice: '',
  minPrice: '',
  page: 1,
  size: 10,
  sortType: 1,
  status: '',
  title: '',
  brandId: '',
})
const cancelList = ref(0)
const pendingProductVariationCount = ref(0)
const noData = ref(false)
const openNotificationKey = ref('')
const configs = ref({
  activeTab: '0',
  open: false,
})
const brandDetail = ref({})
const [api, contextHolder] = notification.useNotification()
const activeBrandOk = async () => {
  let res
  if (activeTab.value == '0') {
    res = await brandApi.activateBrand({ id: brandDetail.value.id })
  } else {
    res = await brandApi.activateBrandAssociate({ id: brandDetail.value.id })
  }

  if (res.success) {
    message.success(i18n.global.t('seller.msg.activateBrandSuccess'))
    multiCancelSure()
    configs.value.open = false
  } else {
    message.error(i18n.global.t('seller.msg.activateBrandFailed'))
  }
}
const close = async (key, brandId) => {
  const res = await brandApi.getBrandDetail({ brandId: brandId })
  // console.log(res,'数据')
  if (res?.success) {
    brandDetail.value = res.data
    configs.value.open = true
    configs.value.activeTab = activeTab.value
    notification.close(openNotificationKey.value)
  }

}
const openNotification = (description, brandId) => {
  const key = `open${Date.now()}`
  openNotificationKey.value = key
   if(paramsObj.value.ids.length>1){
    notification.open({
    message: i18n.global.t('seller.common.notice'),
    description: description,
    placement: 'topRight',
    duration: 0,
    key,
    
        
  })
  }else{
 notification.open({
    message: i18n.global.t('seller.common.notice'),
    description: description,
    placement: 'topRight',
    duration: 0,
    key,
    btn: () =>
      h(
        Button,
        {
          type: 'primary',
          size: 'small',
          onClick: async() => {
            close(key,brandId)
          },
        },
        { default: () => i18n.global.t('seller.common.activateBrand') },
      ),
        
  })
  }
}
const setSelectSingleProduct = (id, record,type) => {
  selectSingleProduct.value = id
  singleRecord.value = record
  singleRecord.value.type = type
}
const setCommission=()=>{
   selectSingleProduct.value=''
   singleRecord.value.type=''
  singleRecord.value = {}
  // console.log(selectedRowKeys.value,'数据')
  showSetCommission.value = true
}
const setShowSetCommission = (status) => {
  showSetCommission.value = status
}

watch(
  () => params.value.sortType,
  () => {
    getData()
  },
)
const resetData = () => {
  return new Promise((resolve) => {
    params.value = {
      availability: '',
      commission: '',
      maxPrice: '',
      minPrice: '',
      page: 1,
      size: 20,
      sortType: 1,
      status: '',
      title: '',
      brandId: '',
    }


    resolve()
  })
}
const cancel = () => {
  cancelSureRef.value.init(productListStatus.pendingOperationIds,productListStatus.pendingProductVariationCount+productListStatus.pendingCount)

}

//  cancelSureRef.value.init()
const onChangeActiveTab = async (val) => {
  await resetData()
  operationBarRef.value.onReset()
  if (activeTab.value == '0') {
    getProductCount()
  } else {
    getAssociateProductCount()
  }
  getData()
}

const getData = async () => {
  // selectedRowKeys.value = []
  if (activeTab.value == '0') {
    await getProductList()
  } else {
    await getAssociateProductList()
  }
  // 翻页后保留选择的数据，不再重置选择模式
  // 如果是当前页选择模式，保持不变
}
const setParams = (data) => {
  params.value = data
}

const setSelectedRowKeys = (data) => {
  selectedRowKeys.value = data
}
const paramsObj = ref({})
const multiCancelSure = async () => {
  loading.value = true
  let res,
    params = paramsObj.value.ids
  if (activeTab.value == '0') {
    if (paramsObj.value.status === 'active') {
      res = await productsApi.activeProduct(params)
    } else {
      res = await productsApi.inactiveProduct(params)
    }
  } else {
    if (paramsObj.value.status === 'active') {
      res = await productsApi.activeAssociateProduct(params)
    } else {
      res = await productsApi.inactiveAssociateProduct(params)
    }
  }
  //  openNotification('测试',brandId)
  const { success, error, code } = res
  if (success) {
    getData()
    message.success(i18n.global.t('seller.msg.success'))
    if (activeTab.value == '0') {
      getProductCount()
    } else {
      getAssociateProductCount()
    }
  } else {
    openNotification(error, brandId)
  }
  loading.value = false
}
const multiCancel = async (ids, status, brandId) => {
  loading.value = true
  let res,
    params = ids
  paramsObj.value = {
    ids: ids,
    status: status,
  }
  if (activeTab.value == '0') {
    if (status === 'active') {
      res = await productsApi.activeProduct(params)
    } else {
      res = await productsApi.inactiveProduct(params)
    }
  } else {
    if (status === 'active') {
      res = await productsApi.activeAssociateProduct(params)
    } else {
      res = await productsApi.inactiveAssociateProduct(params)
    }
  }

  const { success, error, code } = res
  // openNotification("测试",brandId)
  if (success) {
    getData()
    message.success(i18n.global.t('seller.msg.success'))
    if (activeTab.value == '0') {
      getProductCount()
    } else {
      getAssociateProductCount()
    }
  } else {
    openNotification(error, brandId)
  }
  loading.value = false
}
const onChangeActiveItems = async (status, ids, productCount) => {
  //

  tableContentRef.value?.initData(status, ids, activeTab.value, productCount)
}
const changeProducts = (status, productCount) => {
  if (!productCount) {
    return
  }
  let selectIds = []
  if (status === 'deactive') {
    selectIds = productListStatus.inactiveProductIds
  }
  if (status === 'active') {
    selectIds = productListStatus.activeProductIds
  }
  tableContentRef.value?.initData(
    status,
    selectIds,
    activeTab.value,
    productCount,
  )
}
const onSelectChange = async (keys, selectedRows) => {
   selectedRowKeys.value = keys
  // getAssociateProductCount()
  
  if (selectedRowKeys.value.length) {
    await getProductVariations()
  }

}
const getProductVariations = async () => {
  let res
  if (activeTab.value == '0') {
    res = await productsApi.getProductVariationsDetail(
      selectedRowKeys.value,
    )
  } else {
    res = await productsApi.getProductAVariationAssociateDetail(
      selectedRowKeys.value,
    )
  }
  productListStatus.activeProductCount = res.data?.activeProductCount
    ? res.data.activeProductCount
    : 0
  productListStatus.activeProductVariationCount = res.data?.activeProductVariationCount
    ? res.data.activeProductVariationCount
    : 0
  productListStatus.inactiveProductCount = res.data?.inactiveProductCount
    ? res.data.inactiveProductCount
    : 0
  productListStatus.inactiveProductVariationCount = res.data?.inactiveProductVariationCount
    ? res.data.inactiveProductVariationCount
    : 0
  productListStatus.pendingCount = res.data?.pendingCount
    ? res.data.pendingCount
    : 0
  productListStatus.pendingProductVariationCount = res.data?.pendingProductVariationCount
    ? res.data.pendingProductVariationCount
    : 0
  // console.log(productListStatus.pendingOperationIds,'数据',res.data?.pendingOperationIds,res.data?.pendingProductVariationOperationIds)
  if (Array.isArray(res.data?.pendingOperationIds) && Array.isArray(res.data?.pendingProductVariationOperationIds)) {
    productListStatus.pendingOperationIds = [...res.data?.pendingOperationIds, ...res.data?.pendingProductVariationOperationIds]
  }
  if (Array.isArray(res.data?.activeProductIds) && Array.isArray(res.data?.activeProductVariationIds)) {
    productListStatus.activeProductIds = [...res.data?.activeProductIds, ...res.data?.activeProductVariationIds]
  }
  if (Array.isArray(res.data?.inactiveProductIds) && Array.isArray(res.data?.inactiveProductVariationIds)) {
    productListStatus.inactiveProductIds = [...res.data?.inactiveProductIds, ...res.data?.inactiveProductVariationIds]
  }

  // console.log(productListStatus.pendingOperationIds,'数据',res.data?.pendingOperationIds,res.data?.pendingProductVariationOperationIds)
}
const getProductCount = async () => {
  const res = await productsApi.getProductCount()
  const { success, data } = res
  if (success) {
    exportsNum.value = { ...exportsNum.value, ...data }
  }
}
const getAssociateProductCount = async () => {
  const res = await productsApi.getAssociateProductCount()
  const { success, data } = res
  if (success) {
    exportsNum.value = { ...exportsNum.value, ...data }
  }
}
const getAssociateProductList = async (goToTop = false) => {
  loading.value = true
  let newparams = { ...params.value }

  const newParams = (newparams = Object.keys(newparams).reduce((acc, key) => {
    if (key == 'status' && newparams[key] == 'all') {
    } else if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {}))
  const res = await productsApi.getAssociateProductList(newParams)
  const { success, data } = res
  if (success) {
    if (params.value.page > 1 && !data.data.length) {
      setParams({ ...params.value, page: 1 })
      getAssociateProductList()
    } else {
      if (params.value.page === 1) {

      }
      productList.value = data?.data
      productList.value.forEach((item) => {
        if (item?.statusChangeOperations.length) {
          item.timeMonth = moment(item.statusChangeOperations[0].displayTime)
            .tz(timezone)
            .format('MM/DD')
          item.timeMonthName = moment(
            item.statusChangeOperations[0].displayTime,
          )
            .tz(timezone)
            .format('MMM DD,YYYY')
          item.timeMonthNameAll = moment(
            item.statusChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMMM DD,YYYY')
          item.timeMonthNameEOD = moment(
            item.statusChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMM DD,YYYY')
          item.entityType = item.statusChangeOperations[0].entityType
        }
      })

      getProductVariations()

      listTotal.value = data.total
      exportsNum.value.filterProductCount = data.total
      if (goToTop) {
        document.querySelector('.product').scrollIntoView({
          behavior: 'smooth',
        })
      }
      if (!data.data?.length) {
        noData.value = true
        const status = userStore.userInfo.status
        if (status === 'SELLER_PENDING_AGREED_TO_NOTICE') {
          let _user = userStore.userInfo
          _user.status = 'NORMAL'
          userStore.setUserInfo(_user)
        }
      }
    }
  }
  loading.value = false
}
const cancelSureOk = () => {
  getData()
}
const getAllData = async () => {
  loading.value = true
  let newparams = { ...params.value, page: 1, size: 999 }

  const res = await productsApi.getProductList(newparams)
  const { success, data } = res
  if (success && data?.data) {
    // 过滤掉没有id属性的对象，防止访问undefined.id
    selectedRowKeys.value = data.data
      .filter((item) => item && item.id)
      .map((item) => item.id)
  }
  loading.value = false
}
const getProductList = async (goToTop = false) => {
  loading.value = true
  let newparams = { ...params.value }

  const newParams = (newparams = Object.keys(newparams).reduce((acc, key) => {
    if (key == 'status' && newparams[key] == 'all') {
    } else if (
      newparams[key] !== null &&
      newparams[key] !== undefined &&
      newparams[key] !== ''
    ) {
      acc[key] = newparams[key]
    }
    return acc
  }, {}))
  const res = await productsApi.getProductList(newParams)
  const { success, data } = res
  if (success) {
    if (params.value.page > 1 && !data.data.length) {
      setParams({ ...params.value, page: 1 })
      getProductList()
    } else {
      if (params.value.page === 1) {

      }
      productList.value = data.data
      productList.value.forEach((item) => {
        if (item.statusChangeOperations.length) {
          item.timeMonth = moment(item.statusChangeOperations[0].displayTime)
            .tz(timezone)
            .format('MM/DD')
          item.timeMonthName = moment(
            item.statusChangeOperations[0].displayTime,
          )
            .tz(timezone)
            .format('MMM DD,YYYY')
          item.timeMonthNameAll = moment(
            item.statusChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMMM DD,YYYY')
          item.timeMonthNameEOD = moment(
            item.statusChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMM DD,YYYY')
          item.entityType = item.statusChangeOperations[0].entityType
        }
        if (item.commissionChangeOperations.length) {
          item.timeMonthCommission = moment(
            item.commissionChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MM/DD')
          item.timeMonthNameCommission = moment(
            item.commissionChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMM DD,YYYY')
          item.timeMonthNameAllCommission = moment(
            item.commissionChangeOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMMM DD,YYYY')
        }
      })
      getProductVariations()
      listTotal.value = data.total
      exportsNum.value.filterProductCount = data.total
      if (goToTop) {
        document.querySelector('.product').scrollIntoView({
          behavior: 'smooth',
        })
      }
      if (!data.data?.length) {
        noData.value = true
        const status = userStore.userInfo.status
        if (status === 'SELLER_PENDING_AGREED_TO_NOTICE') {
          let _user = userStore.userInfo
          _user.status = 'NORMAL'
          userStore.setUserInfo(_user)
        }
      }
    }
  } else {
    const status = userStore.userInfo.status
    if (status === 'SELLER_PENDING_AGREED_TO_NOTICE') {
      noData.value = true
      let _user = userStore.userInfo
      _user.status = 'NORMAL'
      userStore.setUserInfo(_user)
    } else {
      noData.value = false
    }
  }
  loading.value = false
}

const getBrandswithAvailableProducts = async () => {
  const res = await productsApi.getBrandswithAvailableProducts()
  const { success, data } = res
  if (success && data.length) {
    const list = data.map((item) => {
      item.value = item.id
      item.label = item.amazonBrandName
      if (item.amazonProfileAccountInfoName) {
        item.label += `(${item.amazonProfileAccountInfoName})`
      }
      return item
    })
    brandswithAvailableProducts.value = list
  }
}
const getAmazonNameList = () => {
  connectionApi.getAmazonConnections().then((res) => {
    if (res.success) {
      res.data.data.map((v) => {
        v.label = v.amazonName
        v.value = v.amazonUserId
      })
      amazonNameList.value = res.data.data
    }
  })
}
const checkFromBrandList = () => {
  let paramsFromBrand = store.params
  if (paramsFromBrand && Object.keys(paramsFromBrand).length) {
    params.value.brandId = paramsFromBrand.brandId
    params.value.status = paramsFromBrand.status
    store.setParams({})
  }
}

const checkFromDashboard = () => {
  const artemisAds_dashboard_click_active_products = localStorage.getItem(
    'artemisAds_dashboard_click_active_products',
  )
  if (artemisAds_dashboard_click_active_products === '1') {
    params.value.status = 'active'
    localStorage.setItem('artemisAds_dashboard_click_active_products', '')
  }
}

onBeforeMount(() => {
  checkFromDashboard()
  getBrandswithAvailableProducts()
  getAmazonNameList()
})

onMounted(() => {
  checkFromBrandList()
  // getAssociateProductCount()
  getProductCount()
  // getProductList()
  // if (userStore.userInfo.attributionAssociateSplitCompleted === 'N') {
  //   productModelRef.value.showModal()
  // }

  const { activeTabInfo } = router.currentRoute.value.query
  if (activeTabInfo) {
    activeTab.value = activeTabInfo
  }
    if(route?.query?.type == 'attribution'){
    activeTab.value = '0'
  }
  if(route?.query?.type == 'associate' && !HIDE_ASSOCIATE_PRODUCT_TAB){
    activeTab.value = '1'
  }
  if (HIDE_ASSOCIATE_PRODUCT_TAB && activeTab.value === '1') {
    activeTab.value = '0'
  }
  getData()
})
</script>
<style lang="less" scoped>
.icon-style {
  font-size: 16px;
  color: var(--dark-4);
}

.minus {
  font-size: 10px;
  align-self: center;
  margin-inline: 4px;
  // font-weight: 600;
  line-height: 18px;
  height: 18px;
  color: var(--dark-1);
}

.num-two {
  align-self: center;
  margin-right: 2px;
  height: 18px;
  min-width: 20px;
  padding-inline: 4px;
  background: rgba(255, 211, 88, 0.2);
  border-radius: 4px;
  font-weight: 500;
  font-size: var(--font-size-mormal);
  color: var(--dark-1);
  text-align: center;
  line-height: 16px;
  border: 1px solid rgba(255, 211, 88, 0.4);
}

.product {
  padding: 0 16px 16px;
}

.conetnt {
  position: relative;
}
  .num-two-white{
      background-color: #fff !important;
      color: var(--dark-1) !important;
    }
.bottom-content {
  color: #fff;
  position: sticky;
  bottom: 0px;
  height: 64px;
  left: 0px;
  background-color: #fff;
  border-top: 1px solid rgba(232, 229, 237, 1);
  width: 100%;
  z-index: 999;
  padding: 0 16px;
  display: flex;
  gap: 35px;
  align-items: center;

  .left {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    color: rgba(15, 6, 41, 1);
  }

  .right {
    display: flex;
    gap: 20px;

    .disable {
      background-color: rgba(225, 223, 230, 1) !important;
      border: 1px solid rgba(204, 199, 217, 1) !important;
      color: rgba(15, 6, 41, 0.5) !important;
      cursor: not-allowed !important;
      pointer-events: none !important;

      .num {
        background-color: rgba(255, 255, 255, 0.8) !important;
        color: rgba(15, 6, 41, 0.5) !important;
      }
    }

    .cancel-btn {
      cursor: pointer;
      border-radius: 8px;
      display: flex;
      background-color: rgba(254, 238, 236, 1);
      border: 1px solid rgba(245, 119, 105, 1);
      height: 32px;
      padding: 0 16px;
      align-items: center;
      gap: 6px;
      color: rgba(235, 78, 61, 1);

      .num {
        border-radius: 4px;
        padding: 2px 5px;
        background-color: rgba(255, 211, 88, 1);
        font-family: Sora;
        font-weight: 500;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 14px;
        letter-spacing: 0.4px;

        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .btn-style {
      cursor: pointer;
      border-radius: 8px;
      display: flex;
      background-color: rgba(138, 100, 244, 1);
      height: 32px;
      padding: 0 16px;
      align-items: center;
      gap: 6px;

      .num {
        border-radius: 4px;
        padding: 2px 5px;
        background-color: rgba(255, 211, 88, 1);
        font-family: Sora;
        font-weight: 500;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 14px;
        letter-spacing: 0.4px;
        color: rgba(15, 6, 41, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.content-main {
  // overflow: hidden;
  border-radius: 8px;
  background-color: var(--color-white);
  box-shadow: var(--section-box-shadow-6);

  .content-main-reFetch {
    padding: 14px 16px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--border-4);
  }
}

.content {
  padding: 15px;
}
</style>
